const REACT_ROOT_SELECTOR = '[data-react-root]'
const MORPH_EVENT_NAMES = ['turbo:before-morph-element']

function handleIslandMorph(event) {
  const target = event.target

  if (!(target instanceof Element))
    return

  const islandRoot = target.closest(REACT_ROOT_SELECTOR)
  if (!islandRoot)
    return

  event.preventDefault()

  const rootDescription = islandRoot.id ? `#${islandRoot.id}` : REACT_ROOT_SELECTOR
  const detail = `Turbo morph blocked inside React island (${rootDescription})`

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(
      `[react-island-guard] ${detail}. `
      + 'Keep Turbo morph targets outside [data-react-root].',
      {eventType: event.type, target},
    )
  }

  if (window.newrelic) {
    window.newrelic.noticeError(new Error(detail), {
      eventType: event.type,
      islandRoot: rootDescription,
    })
  }
}

function setupReactIslandGuard() {
  MORPH_EVENT_NAMES.forEach((eventName) => {
    document.addEventListener(eventName, handleIslandMorph, true)
  })

  return () => {
    MORPH_EVENT_NAMES.forEach((eventName) => {
      document.removeEventListener(eventName, handleIslandMorph, true)
    })
  }
}

export default setupReactIslandGuard
